import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { baseURL, getUserProfile } from "../redux/Action";
import { GrMail } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import { useState } from "react";
import AddAddress from "../Components/AddAddress";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Profile = () => {
  const { isAuth, profile, token } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [address, setAddress] = useState(false);
  const [data, setData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      address: data,
    };
    const toastId = toast.loading("Updating...", { theme: "dark" });
    axios
      .put(`${baseURL}/users/user/edit`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Updated Successfully",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        getUserProfile(dispatch);
        setAddress(false);
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "Something went wrong",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  useEffect(() => {
    document.title = "Blogshog | Profile";
    getUserProfile(dispatch);
  }, []);

  if (!isAuth) {
    return <Navigate to="/login"></Navigate>;
  }
  return (
    <>
      <section className="w-[80%] mx-auto pt-10 dark:pb-[19rem]">
        {profile.map((p) => (
          <div
            key={p._id}
            className="flex gap-4 flex-col lg:flex-row justify-center items-center"
          >
            <img className="w-[12rem] rounded-md" src={p.avatar} alt="img" />
            <div>
              <h1 className="dark:text-white">{p.name}</h1>
              <p className="dark:text-white flex items-center gap-2">
                <span>
                  <GrMail />
                </span>
                {p.email}
              </p>
              <div className="flex items-center gap-2 dark:text-white">
                <span>
                  <HiLocationMarker />
                </span>
                {p.addresses.length > 0 && (
                  <>
                    <p>
                      {p.addresses[0].city}, {p.addresses[0].state}
                    </p>
                  </>
                )}
                {p.addresses.length === 0 && (
                  <div className="flex dark:text-white items-center gap-2">
                    <p>No address found!</p>
                    <p
                      className="underline text-indigo-600 cursor-pointer"
                      onClick={() => setAddress(!address)}
                    >
                      {" "}
                      Add Address
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        {address && (
          <AddAddress handleChange={handleChange} handleSubmit={handleSubmit} />
        )}
      </section>
    </>
  );
};

export default Profile;
